module.exports = __webpack_public_path__ + "img/ic_point_4.6fe4741e.svg";